import React from 'react'

export const PageContent = ({ children, style = {}, className = '' }) => {
  return (
    <div className={`content ${className}`} style={style}>
      {children}
    </div>
  )
}
